
export const DEFAULT_ERROR_MESSAGE =
  "Fail to load data. Please try again later.";

export const getErrorMessage = (
  error: unknown,
  fallbackMessage: string = DEFAULT_ERROR_MESSAGE
): string => {
  if (error && typeof error === "object" && "data" in error) {
    const data = (error as { data?: { message?: string } })?.data;
    return data?.message || fallbackMessage;
  }
  return fallbackMessage;
};
